import { NotesProvider } from './../notes/notes';
import { Injectable, EventEmitter } from "@angular/core";
import { Http } from '@angular/http';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import config from "../../app/config";
import { AnalyticsService } from '../../services/analytics.service';

@Injectable()
export class AuthProvider {

	authChanged$: EventEmitter<any>;

	user: string;

	constructor(
		private notesProvider: NotesProvider,
		private analyticsService: AnalyticsService,
		private http: Http,
	) {
		this.authChanged$ = new EventEmitter();

		firebase.initializeApp(config);

		firebase.auth().onAuthStateChanged(user => {
			this.authChanged$.emit(user);
			if (!user) {
				//this.rootPage = 'SplashPage';
				this.user = null;
				this.loginUserAnonymously();
				//unsubscribe();
			} else {
				this.user = user.email;
				//this.rootPage = 'TabsPage';
				this.notesProvider.initNotes();
				//unsubscribe();
			}
		});
	}

	loginUser(email: string, password: string): Promise<any> {
		return firebase.auth().signInWithEmailAndPassword(email, password).then(() => {
			this.analyticsService.trackEvent('Authentication', 'action', 'Login');

			firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function () {
				// Send token to your backend via HTTPS
				// ...
				// console.log(idToken);
			}).catch(function () {
				// Handle error
			});
		});
	}

	loginUserAnonymously(): Promise<any> {
		return firebase.auth().signInAnonymously();
	}

	signupUser(email: string, password: string): Promise<any> {
		return firebase
			.auth()
			.createUserWithEmailAndPassword(email, password)
			.then(newUserCredential => {
				firebase
					.database()
					.ref(`/userProfile/${newUserCredential.user.uid}/email`)
					.set(email);

				this.analyticsService.trackEvent('Authentication', 'action', 'Sign Up');
			})
			.catch(error => {
				console.error(error);
				throw new Error(error);
			});
	}

	resetPassword(email: string): Promise<void> {
		return firebase.auth().sendPasswordResetEmail(email);
	}

	logoutUser(): Promise<void> {
		const userId: string = firebase.auth().currentUser.uid;
		firebase
			.database()
			.ref(`/userProfile/${userId}`)
			.off();

		this.analyticsService.trackEvent('Authentication', 'action', 'Logout');

		return firebase.auth().signOut();
	}

	loggedIn(): boolean {
		let user = firebase.auth().currentUser;
		return user !== null && !user.isAnonymous;
	}

	loggedInAnonymously(): boolean {
		let user = firebase.auth().currentUser;
		return user !== null;
	}

	sendHealthInfoSheetEmail(emailAddress: string, data: any): Promise<any> {
		const url = 'https://xmp0swr1zd.execute-api.ap-southeast-2.amazonaws.com/default/avHealthInformationSheets';

		const postData = {
			to: emailAddress,
			sheet: {
				id: data.sheet.id,
				title: data.sheet.title
			}
		};

		return new Promise((resolve, reject) => {
			this.http.post(url, JSON.stringify(postData)).subscribe(
				(result) => {
					resolve(result)
				},
				() => {
					reject();
				}
			);
		});
	}

}





// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts